<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template v-if="searchShow">
            <el-input
              v-model="search.searchKey"
              clas="input_search"
              clearable
              placeholder="搜索关键字"
              style="margin-right: 10px"
              @keyup.enter.native="getserviceList"
            ></el-input>
            <el-select
              v-model="search.payStatus"
              clearable
              filterable
              placeholder="支付状态"
            >
              <el-option
                v-for="item in PAY_STATUS_1"
                :key="item.key"
                :label="item.name"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-select
              v-model="search.paymentType"
              clearable
              filterable
              placeholder="支付方式"
            >
              <el-option
                v-for="item in paymentList"
                :key="item.paymentType"
                :label="item.name"
                :value="item.paymentType"
              ></el-option>
            </el-select>
            <el-select
              v-model="search.putWay"
              clearable
              filterable
              placeholder="投放方式"
            >
              <el-option
                v-for="item in touFangList"
                :key="item.enumId"
                :label="item.enumName"
                :value="item.enumVal"
              ></el-option>
            </el-select>
            <el-select
              v-model="search.appInfoId"
              clearable
              filterable
              placeholder="下单应用"
            >
              <el-option
                v-for="item in appList"
                :key="item.appInfoId"
                :label="item.appName"
                :value="item.appInfoId"
              ></el-option>
            </el-select>
            <el-select
              v-model="search.channelAccountId"
              clearable
              filterable
              placeholder="下单渠道"
            >
              <el-option
                v-for="item in channelList"
                :key="item.channelAccountId"
                :label="item.name + '(' + item.account + ')'"
                :value="item.channelAccountId"
              ></el-option>
            </el-select>

            <el-select
              v-model="search.countryCode"
              clearable
              filterable
              placeholder="国家/地区"
            >
              <el-option
                v-for="item in countryList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select
              v-model="search.ipCountryCode"
              clearable
              filterable
              placeholder="IP国家/地区"
            >
              <el-option
                v-for="item in countryList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select
              v-model="search.examInfoId"
              clearable
              filterable
              placeholder="测评题"
            >
              <el-option
                v-for="item in examList"
                :key="item.examInfoId"
                :label="item.name"
                :value="item.examInfoId"
              ></el-option>
            </el-select>
            <div class="block timeblock" style="width: 400px; margin-bottom: 10px">
              <el-select
                v-model="search.timeType"
                clearable
                placeholder="选择时间"
                style="margin: 0"
              >
                <el-option
                  v-for="item in TIME_TYPE_1"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
                ></el-option>
              </el-select>
              <el-date-picker
                v-model="value2"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </div>

            <el-button size="medium" type="primary" @click="getserviceList(1)"
              >查询
            </el-button>
          </template>
          <el-button size="medium" type="primary" @click="upserviceList"
            >下载
          </el-button>
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
            row-key="customerServiceId"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="50">
              <template slot-scope="scope">
                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="国家/地区" min-width="90" prop="country">
            </el-table-column>
            <el-table-column label="语言" prop="languageCode" width="50">
            </el-table-column>
            <el-table-column label="标题" min-width="200" prop="title"></el-table-column>
            <el-table-column label="测评题" prop="examQuestion"></el-table-column>

            <el-table-column prop="orderNumber" label="订单号" min-width="210">
            </el-table-column>
            <el-table-column prop="orderType" label="订单类型">
              <template slot-scope="scope">
                <span v-if="scope.row.orderType == 'PLANS_SKU'">订阅SKU</span>
                <span v-else-if="scope.row.orderType == 'SKU_PACKAGE'">方案</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
			<el-table-column
                prop="payName"
                label="商品名称"
                min-width="90"
              ></el-table-column>
            <!-- <el-table-column label="支付ID" min-width="260" prop="payOrderNumber" ></el-table-column> -->
            <el-table-column prop="orderUser" label="下单用户"></el-table-column>

            <!-- <el-table-column prop="orderType" label="状态"></el-table-column> -->

            <!-- <el-table-column label="货币" min-width="120" prop="currency">
						</el-table-column> -->
            <el-table-column label="支付方式" prop="paymentMethod"></el-table-column>
            <el-table-column label="订阅ID" prop="providerSubscriptionId"></el-table-column>


            <el-table-column prop="orderMoneyFormat" label="支付金额">
              <template slot-scope="scope"> $ {{ scope.row.orderMoneyFormat }} </template>
            </el-table-column>
            <el-table-column prop="payStatusText" label="支付状态">
              <template slot-scope="scope">
                <span :style="scope.row.payStatus == 10 ? 'color: #28AB80' : ''">{{
                  scope.row.payStatusText
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="用户IP" min-width="110" prop="ip">
              <template slot-scope="scope">
                <span>{{ scope.row.orderIp }}</span>
                <span
                  >{{ scope.row.provinceName }}
                  <span v-if="scope.row.provinceName">,</span> {{ scope.row.cityName }}
                  <span v-if="scope.row.cityName">,</span> {{ scope.row.areaName }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间" min-width="168">
              <template slot-scope="scope">
                {{ formatDate(scope.row.ctime, "YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>
            <el-table-column label="一转">
              
              <el-table-column
                prop="examOrderNumber"
                label="订单号"
                min-width="200"
              ></el-table-column>
              <!-- <el-table-column label="方案页" prop="schemaPageRenderCompleted">
              </el-table-column>
              <el-table-column label="收银台" prop="payRenderCompleted">
              </el-table-column>
              <el-table-column label="付款页" prop="paymentComponentRenderCompleted">
              </el-table-column> -->
              <!-- <el-table-column label="订单金额" min-width="100" prop="payMoney">
                <template slot-scope="scope"> $ {{ scope.row.payMoney }} </template>
              </el-table-column> -->
              <!-- <el-table-column label="支付状态" prop="payStatusName">
                <template slot-scope="scope">
                  <span :style="scope.row.payStatus === 10 ? 'color: #28AB80' : ''">{{
                    scope.row.payStatusName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="支付失败次数"
                prop="paymentFailNum"
              ></el-table-column>
              <el-table-column
                label="支付回调事件"
                prop="paymentCallbackEvent"
                width="120"
              ></el-table-column> -->
              <el-table-column label="投放方式" prop="deliveryMethod"></el-table-column>
              <el-table-column label="下单应用" min-width="120" prop="orderApp"></el-table-column>
              <el-table-column label="下单渠道" prop="orderChannel" width="180"></el-table-column>
              <!-- <el-table-column label="下单渠道" prop="orderChannel" width="180">
                <template slot-scope="scope">
                  <span
                    >({{
                      !isEmpty(scope.row.channelAccountVo)
                        ? scope.row.channelAccountVo.channelTypeName
                        : ""
                    }}){{
                      !isEmpty(scope.row.channelAccountVo)
                        ? scope.row.channelAccountVo.name
                        : ""
                    }}</span
                  >
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="下单时间" min-width="160" prop="ctime" >
                <template slot-scope="scope">
                  {{ formatDate(scope.row.ctime, 'YYYY-MM-DD HH:mm:ss') }}
                </template>
              </el-table-column>
              <el-table-column label="支付时间" min-width="160" prop="payTime" >
                <template slot-scope="scope">
                  {{ formatDate(scope.row.payTime, 'YYYY-MM-DD HH:mm:ss') }}
                </template>
              </el-table-column> -->
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  v-if="detailShow"
                  @click="getOrderDetail(scope.row)"
                  size="mini"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  PAY_STATUS,
  PAY_STATUS_1,
  PAYMENT_TYPE,
  NEWUSER_ORDER,
  BIZ_TYPE,
  PAY_TYPE,
  TIME_TYPE_1,
} from "@/config";

import { formatDate } from "@/utils/filters/filter";

import { isEmpty } from "@utils/tools/index";
import { downloadFile } from "@/utils/filters/upload.js";

export default {
  data() {
    return {
      PAGE_SIZE,
      PAY_STATUS_1,
      PAYMENT_TYPE,
      NEWUSER_ORDER,
      BIZ_TYPE,
      PAY_TYPE,
      TIME_TYPE_1,
      isEmpty,
      paymentList: [],
      countryList: [],
      examList: [],
      touFangList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "", //以上时间选择器

      enumCode: "PUT_WAY",
      shopList: [], //渠道用户投放方式
      treeProps: {
        //测评题 配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        // value: "parentId",
        children: "examCategoryVos",
        label: "name",
      },

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [], //顶顶那列表

      onTime: "",
      offTime: "", //客服开始和结束时间
      loading: false,

      search: {},
      appList: [],
      channelList: [],
      searchShow: false,
      downShow: false,
      detailShow: false,
      formatDate,
    };
  },
  created() {
    this.getshopList();
    this.getserviceList();
    this.getAppList();
    this.getChannelList();
    this.gettouFangList();
    this.getPermissionButtonList();
    this.getCountryList();
    this.getExamList();
    this.getPaymentList();
  },
  watch: {},
  methods: {
    async getCountryList() {
      const { data: res } = await this.$post(`/country/page`, {
        pageNo: 1,
        pageSize: 1000,
      });
      this.countryList = res.data;
    },
    async getPaymentList() {
      const { data: resData } = await this.$get("/payment/type/list");

      if (resData.result != 200) return;
      this.paymentList = resData.data;
    },
    async getExamList() {
      const { data } = await this.$get(`/exam/list?status=1&pageNo=1&pageSize=1000`);
      this.examList = data.data;
    },
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem("TaotanPermissionButton");
      let arr = JSON.parse(PermissionButtonList);
      if (arr.length) {
        arr.map((item) => {
          if (item.code == "order:secondPay:query") {
            this.searchShow = true;
          }
          if (item.code == "order:secondPay:down") {
            this.downShow = true;
          }
          if (item.code == "order:secondPay:detail") {
            this.detailShow = true;
          }
        });
      }
    },
    // 下载事件
    async upserviceList() {
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == '') {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }
      let obj = this.search
      let startTime = obj.startTime ? obj.startTime : ''
      let endTime = obj.endTime ? obj.endTime : ''
      if (startTime && endTime) {
        // const {data: res} = await this.$get(
        //     `/exam/order/export/create`,
        //     {params: {...this.search}},
        //     {
        //       headers: {
        //         // isLoading: true,
        //       },
        //     }
        // );
        // this.$message.success(res.data)
        let queryString = ''
        for (const key in this.search) {
          if (this.search.hasOwnProperty(key) && this.search[key]) {
            queryString += `${key}=${this.search[key]}&`;
          }
        }
        // 移除字符串末尾的多余的 '&' 符号
        queryString = queryString.slice(0, -1);

        // window.open(`/taotan_admin_api/exam/order/export/examOrder?timeType=${this.search.timeType}&startTime=${startTime}&endTime=${endTime}`);
        const downloadUrl = `/taotan_admin_api/secondPhase/order/export/instant?${queryString}`
        downloadFile(downloadUrl, `examOrder_${new Date().getTime()}.csv`)
      } else {
        this.$message.warning('请选择时间')
      }
    },
    //获取归属应用
    async getAppList() {
      const { data: orgData } = await this.$get(`/app/list?paging=false`);
      this.appList = orgData.data;
    },
    //获取渠道类型
    async getChannelList() {
      const { data: orgData } = await this.$get(`/channel/account/list?paging=false`);
      // const { data: orgData } = await this.$get(`/channel/type/list`);
      this.channelList = orgData.data;
    },
    // 获取渠道用户投放方式
    async gettouFangList() {
      const { data: orgData } = await this.$get(`/enums/list/${this.enumCode}`);

      this.touFangList = orgData.data;
    },
    // 获取渠道 商户
    async getshopList() {
      // payment/mch/list?pageNo=1&pageSize=10
      // const { data: orgData } = await this.$get(`/channel/mch/list`);
      const { data: orgData } = await this.$get(`payment/mch/list?paging=false`);
      this.shopList = orgData.data;
    },

    //订单列表
    async getserviceList(e) {
      if (e == 1) {
        this.page.pageNo = 1;
      }
      if (this.value2 && this.value2.length) {
        if (this.search.timeType == undefined || this.search.timeType == "") {
          this.$message.warning("请先选择筛选时间类型");
          return;
        }
        this.search.startTime = this.value2[0];
        this.search.endTime = this.value2[1];
      } else {
        delete this.search.startTime;
        delete this.search.endTime;
        delete this.search.timeType;
      }
      if (this.search.timeType) {
        if (this.value2 == undefined || this.value2 == "") {
          this.$message.warning("请选择起止时间");
          return;
        }
      }

      this.loading = true;
      this.removeEmptyProperties(this.search);
      const { data: res } = await this.$get(
        `/secondPhase/order/list`,
        { params: { ...this.search, ...this.page } },
        {
          headers: {
            isLoading: true,
          },
        }
      );
      this.loading = false;
      let list = res.data.records;
      if (list) {
        list.forEach((item, index) => {
          item.payMoney = item.payMoney / 100;
        });
      }
      this.tableData = list;
      this.page.count = res.data.total;
    },
    removeEmptyProperties(obj) {
      for (const key in obj) {
        if (
          obj.hasOwnProperty(key) &&
          (obj[key] === null || obj[key] === undefined || obj[key] === "")
        ) {
          delete obj[key];
        }
      }
    },
    //订单详情
    async getOrderDetail(row) {
      this.$router.push({
        name: "SECOND_ORDER_DETAIL",
        query: {
          id: 2,
          title: "支付订单",
          key: "payCode",
          value0: JSON.stringify(row.examOrderNumber),
          value: JSON.stringify(row.orderNumber),
          path: `/secondPhase/order/info/${row.id}`,
        },
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
.el-select {
  margin-bottom: 10px;
  margin-right: 10px;
}
</style>
